export default {
      id: "video-event_over-max-speed-usage",
      viewBox: "0 0 44 26",
      url: __webpack_public_path__ + "img/icons.svg#video-event_over-max-speed",
      toString: function () {
        return this.url;
      }
    }